This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div>
    <div class="basicBlock" v-if="activeClassroom == null">
      <p class="header upper">
        {{ $t("classroomPackages.selectClassroom") }}
      </p>
    </div>
    <div class="basicBlock" v-else>
      <p class="header upper">
        {{ activeClassroom.name }}
      </p>
      <div
        v-for="b in this.bundles"
        :key="b.bundleId"
        class="selectable blockEntry grid-cols-5 buttonsRight leftRight"
      >
        <p>{{ b.name }}</p>
        <button class="button warning" @click="removeBundle(b)">
          <img src="@/assets/images/icons/Min.svg" alt="Minus icon" />
        </button>
      </div>
      <div class="buttonsCenter">
        <div class="spaceAbove noUpperLine">
          <button class="button warning" @click="getBundles(activeClassroom)">
            {{ $t("classroomPackages.reset") }}
          </button>
        </div>
        <div class="spaceAbove noUpperLine">
          <button class="button success" @click="saveClassroom">
            {{ $t("classroomPackages.update") }}
          </button>
        </div>
        <div class="overlay" v-bind:class="{ overlayVisible: overlay }">
          <div class="message">
            <p class="messageHeader success">Success</p>
            <p>{{ $t("classroomPackages.success") }}</p>
            <div class="buttonsCenter">
              <button class="button success" @click="overlay = false">
                {{ $t("classroomPackages.ok") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { classAPI } from "@/utils/apiCalls";
import { classroom, bundle } from "@/utils/Types";

@Options({
  data() {
    return {
      bundles: [] as bundle[],
      toRemove: [] as bundle[],
      overlay: false,
      original: [] as bundle[],
    };
  },
  watch: {
    //Get bundles on active classroom change
    activeClassroom: function (newVal) {
      this.getBundles(newVal);
    },
  },
  methods: {
    /**
     * Get bundles
     * @param c Classroom
     */
    async getBundles(c: classroom) {
      await classAPI.getBundles(c.classroomId).then((value) => {
        this.bundles = value;
        this.$store.commit("setClassroomBundles", value);
        this.$emit("updateAvailableBundles", this.bundles);
      });
    },
    /**
     * Remove bundle
     * @param b Bundle
     */
    removeBundle(b: bundle) {
      const index = this.bundles.indexOf(b, 0);
      this.$emit("removeBundle", b);
      this.bundles.splice(index, 1);
      this.toRemove.push(b);
    },
    /**
     * Add bundle
     * @param b Bundle
     */
    addBundle(b: bundle) {
      if (this.toRemove.includes(b)) {
        this.toRemove.splice(this.toRemove.indexOf(b), 1);
      }
      this.bundles.push(b);
    },
    //Save classroom
    async saveClassroom() {
      for (let bu of this.toRemove) {
        await classAPI.removeBundle(
          this.$props.activeClassroom.classroomId,
          bu.bundleId
        );
      }
      for (let b of this.bundles) {
        await classAPI.addBundle(
          this.$props.activeClassroom.classroomId,
          b.bundleId
        );
      }
      this.overlay = true;
      this.original = this.bundles;
    },
  },
  props: ["activeClassroom"],
})
export default class ClassroomBundlesBlock extends Vue {}
</script>
